import { API_VERSION } from '../config/configurations';
import { edulaiInstance } from './instances/edulaiInstance';

export const getReport = async (language, userId, quizId = null) =>
  edulaiInstance.get(`/api/${API_VERSION}/reports`, { params: { quizId, userId, lang: language } });
